/**
 * Анимация курсора в макете формы на главной.
 *
 * gsap (367 КБ исходника) и плагин ScrollTrigger загружаются динамически:
 * разметка `.form-home__image` есть только на одном шаблоне темы.
 * Регистрация плагина раньше шла до проверки разметки — из-за этого
 * библиотека попадала в основной бандл.
 */

export default async function FormAnimation() {
    const formImages = document.querySelectorAll(".form-home__image");
    if (!formImages.length) return;

    const [{default: gsap}, {default: ScrollTrigger}] = await Promise.all([
        import("gsap"),
        import("gsap/ScrollTrigger"),
    ]);

    gsap.registerPlugin(ScrollTrigger);

    formImages.forEach((container) => {
        const cursor = container.querySelector(".cursor");
        if (!cursor) return;

        const cursorDrop = cursor.querySelector(".cursor-drop");
        const items = container.querySelectorAll(".form-home__image-item");

        function moveCursorTo(isRight, element, delay, onComplete) {
            if (!element) return;
            const rect = element.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();

            gsap.to(cursor, {
                x: !isRight ? rect.right - containerRect.right - 200 : rect.right - containerRect.right + 30,
                y: rect.top - containerRect.top + 10,
                duration: 1,
                ease: "power2.inOut",
                delay: delay || 0,
                onComplete: onComplete
            });
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: container,
                start: "top center",
                toggleActions: "play none none none"
            },
            repeat: -1
        });

        gsap.set(cursor, { right: 20, top: 20 });

        tl.to({}, { duration: 1 })
            .call(() => moveCursorTo(false, items[0], 0, () => {
                cursorDrop.classList.remove("hidden");
                items[0]?.classList.add("form-home__image-item--active");
                setTimeout(() => cursorDrop.classList.add("hidden"), 500);
            }))
            .to({}, { duration: 2.5 })
            .call(() => items[0]?.classList.remove("form-home__image-item--active"))
            .to({}, { duration: 1.5 })
            .call(() => moveCursorTo(true, items[2], 0, () => {
                cursorDrop.classList.remove("hidden");
                items[2]?.classList.add("form-home__image-item--active");
                setTimeout(() => cursorDrop.classList.add("hidden"), 500);
            }))
            .to({}, { duration: 2.5 })
            .call(() => items[2]?.classList.remove("form-home__image-item--active"))
            .to({}, { duration: 1.5 })
            .to(container, { scrollTop: container.scrollHeight, duration: 2, speed: 0.3 })
            .to({}, { duration: 0.5 })
            .to(container, { scrollTop: 0, duration: 2 })
            .to({}, { duration: 0.5 });
    });
}
